import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ClipboardJS from 'clipboard';
import * as React from 'react';
import { Alert } from 'reactstrap';
import { Button, FormGroup, Input, Label } from 'reactstrap';

const Result = (
  props: {
    readonly uuid: string;
    readonly password: string;
  } & React.HTMLAttributes<HTMLElement>,
) => {
  const base = `${window.location.protocol}//${window.location.host}/#/s`;
  const short = `${base}/${props.uuid}`;
  const full = `${short}/${props.password}`;

  return (
    <div>
      <Alert color="success">
        Secret succesfully stored on the server.
      </Alert>
      <Alert color="warning">
        Remember that the secret link can only be opened <b>once</b> so do not open the link yourself.
      </Alert>
      <CopyField name="full" label="Onetime secret link" value={full} />
    </div>
  );
};

const CopyField = (
  props: {
    readonly label: string;
    readonly name: string;
    readonly value: string;
  } & React.HTMLAttributes<HTMLElement>,
) => {
  // @ts-ignore
  const clip = new ClipboardJS(`#${props.name}-b`, {
    target: () => document.getElementById(`${props.name}-i`),
  });

  return (
    <FormGroup>
      <Label>{props.label}</Label>
      <div className="input-group mb-3">
        <div className="input-group-append">
          <Button color="primary" id={`${props.name}-b`}>
            {' '}
            <FontAwesomeIcon icon={faCopy} />
          </Button>
        </div>
        <Input readOnly={true} id={`${props.name}-i`} value={props.value} />
      </div>
    </FormGroup>
  );
};
export default Result;



// WEBPACK FOOTER //
// ./src/Result.tsx